import React from 'react';

    function Section(props) {
        const { className } = props;
        return (
            <section className={className} >
                <div className="pd-main container relative">
                    {props.children}
                </div>
            </section>
            );
    };
export default Section;


/** WEBPACK FOOTER **
 ** ./src/components/Section.js
 **/